/**
 * Max lengths of the backend's length-limited text columns: mirror of
 * StabilimentumCMS.Domain/Constants/FieldLengths.cs, keep both in sync.
 * The backend rejects longer values with a 400; these let the forms stop them first.
 */
export const FieldLengths = {
    adminUserDisplayName: 100,
    adminUserEmail: 200,
    fileName: 255,
    galleryTitle: 200,
    imageAlt: 100,
    listItemText: 100,
    listItemLink: 200,
    postHeadline: 200,
    postDescription: 200,
    postHtmlText: 20000,
    postLink: 200,
    translationValue: 10000,
} as const;
